import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { VehicleFingerprintContext } from '../../vehicle-fingerprint.models';
import { formatFingerprintMetric } from '../../vehicle-fingerprint.utils';

@Component({
  selector: 'app-vehicle-fingerprint-geographic-signature',
  templateUrl: './geographic-signature.component.html',
  styleUrls: ['../../summary-panels.css', './geographic-signature.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleFingerprintGeographicSignatureComponent {
  @Input() context: VehicleFingerprintContext = { summary: null, unitId: '' };

  readonly formatValue = formatFingerprintMetric;

  get coordinates(): string {
    const summary = this.context.summary;
    const latitude = summary?.fCenterLatitude;
    const longitude = summary?.fCenterLongitude;
    if (typeof latitude !== 'number' || !Number.isFinite(latitude) || Math.abs(latitude) > 90
      || typeof longitude !== 'number' || !Number.isFinite(longitude) || Math.abs(longitude) > 180) return '—';
    return `${formatFingerprintMetric(summary, 'fCenterLatitude', 5)}, ${formatFingerprintMetric(summary, 'fCenterLongitude', 5)}`;
  }
}
